<div class="user-success-submitted">
  <div class="cds-h2-demibold">
    {{ 'confirmation.successMessage' | lang }}
  </div>
  <div class="btn-box">
    <cds-button [config]="agreeButtonConfig" (click)="agree()" label="{{ 'confirmation.ok' | lang }}"></cds-button>
  </div>
</div>
